/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { computed } from 'vue';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-8d19eb1a.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../_chunks/dep-adebe2ce.mjs';
import '../_chunks/dep-bd3d75f1.mjs';
import '../_chunks/dep-2b8d75e2.mjs';
import '../_chunks/dep-8f44163a.mjs';
import '../_chunks/dep-a255de71.mjs';
import '../_chunks/dep-ebe8bc2f.mjs';
import '../_chunks/dep-cc371884.mjs';
import '../_chunks/dep-1f0070bb.mjs';
import '../_chunks/dep-9d0d32fd.mjs';
import '../_chunks/dep-ebfafd52.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../_chunks/dep-b9567f6a.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-a11a63ea.mjs';
import '../_chunks/dep-750294df.mjs';
import '../_chunks/dep-ad1accf9.mjs';
import '../_chunks/dep-e05e20e6.mjs';
import '../_chunks/dep-3e3494dc.mjs';
import '../_chunks/dep-42be3824.mjs';
import '../_chunks/dep-67dfe9c7.mjs';
import '../_chunks/dep-7f2f03b4.mjs';
import '../_chunks/dep-a0bd2e3a.mjs';
import '../_chunks/dep-91208ac3.mjs';
import '../_chunks/dep-1041f7d7.mjs';
import '../_chunks/dep-b32fb318.mjs';
import '../_chunks/dep-9b57842b.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-99a0abba.mjs';
import '../_chunks/dep-9d5ee0e1.mjs';
import '../config-provider/type.mjs';

var useCLASSNAMES = function useCLASSNAMES() {
  var classPrefix = usePrefixClass();
  return computed(function () {
    var tree = "".concat(classPrefix.value, "-tree");
    return {
      icon: "".concat(classPrefix.value, "-icon"),
      folderIcon: "".concat(classPrefix.value, "-folder-icon"),
      actived: "".concat(classPrefix.value, "-is-active"),
      disabled: "".concat(classPrefix.value, "-is-disabled"),
      treeIconRight: "".concat(classPrefix.value, "-icon-arrow-right"),
      treeIconDown: "".concat(classPrefix.value, "-icon-arrow-down"),
      treeNodeToggle: "".concat(classPrefix.value, "-tree-toggle"),
      tree: tree,
      treeTransition: "".concat(tree, "--transition"),
      treeBlockNode: "".concat(tree, "--block-node"),
      treeEmpty: "".concat(tree, "__empty"),
      treeList: "".concat(tree, "__list"),
      treeNode: "".concat(tree, "__item"),
      treeNodeOpen: "".concat(tree, "__item--open"),
      treeHoverAble: "".concat(tree, "--hoverable"),
      treeCheckable: "".concat(tree, "--checkable"),
      treeLabel: "".concat(tree, "__label"),
      treeLabelStrictly: "".concat(tree, "__label--strictly"),
      treeIcon: "".concat(tree, "__icon"),
      treeIconDefault: "".concat(tree, "__icon--default"),
      treeSpace: "".concat(tree, "__space"),
      treeOperations: "".concat(tree, "__operations"),
      treeNodeVisible: "".concat(tree, "__item--visible"),
      treeNodeHidden: "".concat(tree, "__item--hidden"),
      treeNodeEnter: "".concat(tree, "__item--enter-active"),
      treeNodeLeave: "".concat(tree, "__item--leave-active"),
      treeNodeDraggable: "".concat(tree, "__item--draggable"),
      treeNodeDragging: "".concat(tree, "__item--dragging"),
      treeNodeDragTipTop: "".concat(tree, "__item--tip-top"),
      treeNodeDragTipBottom: "".concat(tree, "__item--tip-bottom"),
      treeNodeDragTipHighlight: "".concat(tree, "__item--tip-highlight"),
      line: "".concat(tree, "__line"),
      lineIsLeaf: "".concat(tree, "__line--leaf"),
      lineIsFirst: "".concat(tree, "__line--first")
    };
  });
};
var injectKey = Symbol("treeProvider");
var dragInjectKey = Symbol("onDrag");

export { dragInjectKey, injectKey, useCLASSNAMES };
//# sourceMappingURL=constants.mjs.map
